module.exports = __webpack_public_path__ + "img/chevron-right-duo.07f84522.svg";